module.exports = __webpack_public_path__ + "media/7.1ea20740.mp3";